module.exports = __webpack_public_path__ + "static/media/nintendoWhite@2x.dff6c121.png";